import { RouteObject } from 'react-router';

import { AttributesContainer } from './containers/AttributesContainer';

const routes: RouteObject[] = [
    {
        path: 'attributes',
        element: <AttributesContainer />,
    },
];
export default routes;
